// Copyright (c) 2016 Deere & Company

import KeyValuePair, {getDefaultState as getKeyValueDefaultState} from './key-value-pair';
import t from 'tcomb';

const PipHistory = t.struct({
    completedDate: t.Number,
    daysLeft: t.Number,
    description: t.String,
    dtac: t.String,
    dtacUrl: t.String,
    expireDate: t.Number,
    internalRecall: t.String,
    metric: KeyValuePair,
    participant: KeyValuePair,
    pipCode: t.String,
    pipCompletionStatus: KeyValuePair,
    pipId: t.String,
    pipNumber: t.String,
    specialInstructions: t.String,
    startDate: t.Number,
    status: KeyValuePair,
    statusReason: t.String,
    terminationDate: t.Number,
    type: KeyValuePair
}, {
    name: 'PipHistory',
    strict: true
});

export const getDefaultState = () => new PipHistory({
    completedDate: 0,
    daysLeft: 0,
    description: '',
    dtac: '',
    dtacUrl: '',
    expireDate: 0,
    internalRecall: '',
    metric: getKeyValueDefaultState(),
    participant: getKeyValueDefaultState(),
    pipCode: '',
    pipCompletionStatus: getKeyValueDefaultState(),
    pipId: '',
    pipNumber: '',
    specialInstructions: '',
    startDate: 0,
    status: getKeyValueDefaultState(),
    statusReason: '',
    terminationDate: 0,
    type: getKeyValueDefaultState()
});

export default PipHistory;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/pip-history.js